/* ============================================================================
   cb-constellation.js  —  v8 Constellation Dawn  (SHARED — loaded ONCE by
   sections/cb-header.liquid via <script src="{{ 'cb-constellation.js' | asset_url }}" defer>)
   ----------------------------------------------------------------------------
   Extracted from cb-ultra-v8.html's two inline <script> blocks (core + deferred),
   built by Marcus. REMOVED: the Tier-4 hidden dev-panel script, its 2 styled
   startup log banners, and the math-typesetting lazy-loader (the one SFE
   formula is pre-rendered to static MathML by Liam).

   HARDENING applied to the deferred block (see inline "HARDENING (Marcus)" notes):
     1. section:load hygiene — the core IIFE already re-queries chrome nodes and
        binds inside an idempotent cbBind() (once()-guarded) that runs on
        DOMContentLoaded AND shopify:section:load; preserved verbatim.
     2. IO-gated constellation canvas + single loop/context — per-canvas dataset
        guard so a section reload never spawns a 2nd rAF loop or 2D context.
     3. (2026-07-06) silhouette morphs REMOVED per owner — the sky is a free
        scatter field that drifts/rotates; the nebula poster rotates with it.
     4. Asset URLs — model-viewer library src + spin frames come from the
        #cb-assets JSON map (Shopify asset_url); no relative-preview or
        third-party-CDN paths here.

   Two independent IIFEs, as in the source. No module bundler; ES5-safe.
============================================================================ */

(function () {
  "use strict";
  var $ = function (s, c) {
    return (c || document).querySelector(s);
  };
  var $$ = function (s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  };
  var RM = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var isLive =
    /(^|\.)myshopify\.com$|(^|\.)e-cafebank\.com$/.test(location.hostname) ||
    !!window.Shopify;

  function once(el) {
    if (el.dataset.cbBound) return false;
    el.dataset.cbBound = "1";
    return true;
  }

  /* ---- sticky-header stuck check: ONE rAF-throttled passive scroll listener ---- */
  var header = $("#cb-header");
  var stuck = false,
    ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var s = window.scrollY > 4;
      if (s !== stuck && header) {
        stuck = s;
        header.classList.toggle("is-stuck", s); /* write-on-change only */
      }
    });
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---- toast ---- */
  var toast = $("#cb-toast");
  var toastTimer = null;
  function showToast(title, sub) {
    if (!toast) return;
    $("#cb-toast-title").textContent = title;
    $("#cb-toast-sub").textContent = sub;
    toast.removeAttribute("inert");
    toast.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4000);
  }
  function hideToast() {
    if (!toast) return;
    toast.classList.remove("is-on");
    toast.setAttribute("inert", "");
  }

  /* ---- cart count ---- */
  var cartN = 0;
  function paintCart(n) {
    var b = $("#cb-cart-count");
    if (!b) return;
    b.textContent = String(n);
    b.hidden = n <= 0;
    paintStickyCount(n);
  }
  /* audit 2026-07-05: initialize the badge from the existing cart on load,
     and mirror the count into the sticky buy bar when present */
  function paintStickyCount(n) {
    var sc = $("#cb-sticky-count");
    if (sc) sc.textContent = n > 0 ? " (" + n + ")" : "";
  }
  function initCart() {
    if (!isLive) return;
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        paintCart(c.item_count || 0);
        paintStickyCount(c.item_count || 0);
      })
      .catch(function () {});
  }
  /* self-contained scheduling — `idle` helper lives in a later scope (caused a
     load-time ReferenceError that killed the whole file, 2026-07-05) */
  if ("requestIdleCallback" in window)
    requestIdleCallback(initCart, { timeout: 3000 });
  else setTimeout(initCart, 1500);
  function bumpCart() {
    if (isLive) {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          paintCart(c.item_count || 0);
        })
        .catch(function () {});
    } else {
      cartN += 1;
      paintCart(cartN);
    }
  }

  /* ---- mobile drawer: inert + focus trap ---- */
  var drawer = $("#cb-drawer"),
    scrim = $("#cb-scrim"),
    burger = $("#cb-burger"),
    scrimTimer = null;
  function drawerFocusables() {
    return $$(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
      drawer,
    );
  }
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    if (open) drawer.removeAttribute("inert");
    else drawer.setAttribute("inert", "");
    if (burger) burger.setAttribute("aria-expanded", String(open));
    if (scrim) {
      clearTimeout(
        scrimTimer,
      ); /* fast reopen must not be re-hidden by a stale timer */
      if (open) {
        scrim.hidden = false;
        requestAnimationFrame(function () {
          scrim.classList.add("is-on");
        });
      } else {
        scrim.classList.remove("is-on");
        scrimTimer = setTimeout(function () {
          scrim.hidden = true;
        }, 260);
      }
    }
    document.documentElement.style.overflow = open ? "hidden" : "";
    /* audit item 6 (2026-07-05): hide the page behind the drawer from
       assistive tech while it is open */
    var behindMain = document.getElementById("MainContent");
    var behindHdr = document.getElementById("cb-header");
    [behindMain, behindHdr].forEach(function (el) {
      if (!el) return;
      if (open) el.setAttribute("inert", "");
      else el.removeAttribute("inert");
    });
    if (open) {
      var f = drawerFocusables()[0];
      if (f) f.focus();
    } else if (burger) burger.focus();
  }
  document.addEventListener("keydown", function (e) {
    if (!drawer || !drawer.classList.contains("is-open")) return;
    if (e.key === "Escape") {
      setDrawer(false);
      return;
    }
    if (e.key !== "Tab") return;
    var f = drawerFocusables();
    if (!f.length) return;
    var first = f[0],
      last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      last.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === last) {
      first.focus();
      e.preventDefault();
    } else if (!drawer.contains(document.activeElement)) {
      first.focus();
      e.preventDefault();
    }
  });

  /* ---- desktop dropdowns: keyboard/aria (hover handled by CSS) ---- */
  document.addEventListener("click", function (e) {
    var openLis = $$(".cb-c8-menu li.is-open");
    openLis.forEach(function (li) {
      if (!li.contains(e.target)) {
        li.classList.remove("is-open");
        var b = li.querySelector(".cb-c8-hasdrop");
        if (b) b.setAttribute("aria-expanded", "false");
      }
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    $$(".cb-c8-menu li.is-open").forEach(function (li) {
      li.classList.remove("is-open");
      var b = li.querySelector(".cb-c8-hasdrop");
      if (b) b.setAttribute("aria-expanded", "false");
    });
  });

  /* ---- reveal-on-scroll (ONE observer, reused across section reloads) ---- */
  var revealIO = null;
  function initReveals() {
    var els = $$(".cb-c8-reveal:not(.is-in)");
    if (RM || !("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("is-in");
      });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add("is-in");
              revealIO.unobserve(en.target);
            }
          });
        },
        { rootMargin: "0px 0px -8% 0px", threshold: 0.06 },
      );
    }
    els.forEach(function (el) {
      if (!el.dataset.cbRevealObs) {
        el.dataset.cbRevealObs = "1";
        revealIO.observe(el);
      }
    });
  }

  /* ============ bindings: idempotent, re-run on shopify:section:load ============ */
  function cbBind() {
    /* re-query chrome nodes — theme-editor section reloads replace them (S5) */
    header = $("#cb-header");
    drawer = $("#cb-drawer");
    scrim = $("#cb-scrim");
    burger = $("#cb-burger");
    toast = $("#cb-toast");

    /* keep aria-expanded in sync with the CSS hover/focus-within open
             state (S11) — click toggling still owns li.is-open */
    $$(".cb-c8-menu > li").forEach(function (li) {
      var db = li.querySelector(".cb-c8-hasdrop");
      if (!db || li.dataset.cbAria) return;
      li.dataset.cbAria = "1";
      function sync(open) {
        db.setAttribute("aria-expanded", open ? "true" : "false");
      }
      li.addEventListener("mouseenter", function () {
        sync(true);
      });
      li.addEventListener("mouseleave", function () {
        if (!li.classList.contains("is-open")) sync(false);
      });
      li.addEventListener("focusin", function () {
        sync(true);
      });
      li.addEventListener("focusout", function (ev) {
        if (!li.contains(ev.relatedTarget) && !li.classList.contains("is-open"))
          sync(false);
      });
    });

    if (burger && once(burger))
      burger.addEventListener("click", function () {
        setDrawer(true);
      });
    var dClose = $("#cb-drawer-close");
    if (dClose && once(dClose))
      dClose.addEventListener("click", function () {
        setDrawer(false);
      });
    if (scrim && once(scrim))
      scrim.addEventListener("click", function () {
        setDrawer(false);
      });
    $$("#cb-drawer a[href]").forEach(function (a) {
      if (!once(a)) return;
      a.addEventListener("click", function () {
        setDrawer(false);
      });
    });

    /* drawer accordions */
    $$(".cb-c8-macc > li > button.cb-c8-macc__top").forEach(function (b) {
      if (!once(b)) return;
      b.addEventListener("click", function () {
        var li = b.parentElement;
        var open = li.classList.toggle("is-open");
        b.setAttribute("aria-expanded", String(open));
      });
    });

    /* desktop dropdown buttons (keyboard toggle) */
    $$(".cb-c8-hasdrop").forEach(function (b) {
      if (!once(b)) return;
      b.addEventListener("click", function () {
        var li = b.parentElement;
        var open = li.classList.toggle("is-open");
        b.setAttribute("aria-expanded", String(open));
      });
    });

    /* toast close */
    var tcl = $("#cb-toast-close");
    if (tcl && once(tcl)) tcl.addEventListener("click", hideToast);

    /* quick-add: native /cart/add POST is the baseline (works with JS
             off and whenever AJAX prerequisites fail); JS upgrades it to the
             /cart/add.js JSON endpoint + toast. preventDefault only once the
             AJAX path is viable; transport failure falls back to form.submit(). */
    $$("form[data-cb-add]").forEach(function (form) {
      if (!once(form)) return;
      form.addEventListener("submit", function (e) {
        var sel = form.querySelector("[data-cb-variant]");
        if (
          isLive &&
          (!sel || !sel.value || !window.fetch || !window.Promise)
        ) {
          return; /* let the native /cart/add POST run */
        }
        e.preventDefault();
        var opt = sel ? sel.options[sel.selectedIndex] : null;
        var card = form.closest(".cb-c8-pcard");
        var titleEl = card && card.querySelector(".cb-c8-pcard__title");
        var title = titleEl ? titleEl.textContent.trim() : "Item";
        var vtext = opt ? opt.textContent.trim() : "";
        var btn = form.querySelector("[data-cb-addbtn]");
        if (btn) {
          btn.disabled = true;
          btn.textContent = "Adding…";
        }
        function restore() {
          if (btn) {
            btn.disabled = false;
            btn.textContent = "Add to Cart";
          }
        }
        function ok() {
          bumpCart();
          showToast(
            "Added to cart",
            title.slice(0, 46) + " · " + vtext + " · Free worldwide shipping",
          );
          restore();
        }
        function fail() {
          restore();
          showToast(
            "Couldn’t add to cart",
            "Please try again, or open the product page.",
          );
        }
        if (!isLive) {
          setTimeout(ok, 260);
          return;
        }
        /* JSON must go to /cart/add.js — Dawn's routes.cart_add_url is
                 the HTML /cart/add endpoint (S8) */
        var addUrl =
          (window.routes && window.routes.cart_add_url) || "/cart/add";
        if (!/\.js$/.test(addUrl)) addUrl += ".js";
        fetch(addUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [{ id: Number(sel.value), quantity: 1 }],
          }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error("cb-add-http");
            /* 2xx = added; tolerate a body that fails to parse */
            return r.json().catch(function () {
              return null;
            });
          })
          .then(ok)
          .catch(function (err) {
            if (err && err.message === "cb-add-http") fail();
            else {
              restore();
              form.submit(); /* fetch/CSP/runtime failure → native POST */
            }
          });
      });
    });

    /* newsletter — Klaviyo client API on live (r.ok required, honest
             failure state); native Shopify /contact customer POST is the
             JS-off / fallback path so the lead is never silently dropped. */
    var nf = $("#cb-news-form");
    if (nf && once(nf))
      nf.addEventListener("submit", function (e) {
        var em = $("#cb-news-email");
        var okEl = $("#cb-news-ok");
        if (!em || !okEl) return;
        var email = em.value.trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          e.preventDefault();
          okEl.textContent = "Please enter a valid email address.";
          return;
        }
        function good() {
          okEl.textContent = "Welcome aboard — check your inbox to confirm.";
          em.value = "";
        }
        function bad() {
          okEl.textContent =
            "Something went wrong — please try again in a moment.";
        }
        if (!isLive) {
          e.preventDefault(); /* preview: no live endpoint to hit */
          good();
          return;
        }
        var company = nf.dataset.klaviyoCompany,
          list = nf.dataset.klaviyoList;
        if (!window.fetch || !company || !list) {
          return; /* native Shopify customer-capture POST */
        }
        e.preventDefault();
        fetch(
          "https://a.klaviyo.com/client/subscriptions/?company_id=" +
            encodeURIComponent(company),
          {
            method: "POST",
            headers: {
              "Content-Type": "application/vnd.api+json",
              revision: "2025-07-15",
            },
            body: JSON.stringify({
              data: {
                type: "subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: { email: email },
                    },
                  },
                },
                relationships: {
                  list: { data: { type: "list", id: list } },
                },
              },
            }),
          },
        )
          .then(function (r) {
            if (r.ok) good();
            else nf.submit(); /* non-OK → native Shopify capture */
          })
          .catch(function () {
            nf.submit(); /* transport failure → native Shopify capture */
          });
      });

    /* chat bubble */
    var chatBtn = $("#cb-chat-btn"),
      chat = $("#cb-chat");
    if (chatBtn && once(chatBtn))
      chatBtn.addEventListener("click", function () {
        var open = chat.classList.toggle("is-open");
        chatBtn.setAttribute("aria-expanded", String(open));
      });

    initReveals();
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", cbBind);
  else cbBind();
  document.addEventListener("shopify:section:load", cbBind);
})();

(function () {
  "use strict";
  var RM = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var SAVE = (navigator.connection && navigator.connection.saveData) || false;
  var SMALL = matchMedia("(max-width: 749px)").matches;
  var LOWMEM =
    typeof navigator.deviceMemory === "number" && navigator.deviceMemory < 4;

  /* Asset map emitted by sections/cb-header.liquid (#cb-assets):
           { modelViewer, glb, poster, spin:[url0..url35] } — every URL is a
           Shopify asset_url. No hardcoded relative-preview or third-party-CDN
           paths live in this file; the model-viewer library src and the spin
           frames both resolve through this map. */
  function getAssets() {
    /* HARDENING (Marcus, item 6): read the #cb-assets map FRESH at call time
             (was a page-load-time constant) so a Customizer asset swap applied on
             shopify:section:load is picked up instead of a stale, cached map. */
    try {
      var el = document.getElementById("cb-assets");
      return (el && JSON.parse(el.textContent || "{}")) || {};
    } catch (e) {
      return {};
    }
  }

  function idle(fn, t) {
    if ("requestIdleCallback" in window)
      requestIdleCallback(fn, { timeout: t || 2500 });
    else setTimeout(fn, 1200);
  }

  /* Page-level model-viewer readiness. mvReady is a shared Promise so the
         module is injected at most once per page, AND a theme-editor section
         reload that arrives WHILE the module is still loading still gets its
         FRESH nodes wired when the element defines — instead of the first
         closure wiring now-detached nodes and the reload's nodes being dropped
         by a stale "already scheduled" early-return. HARDENING (Marcus, item 4). */
  var mvReady = null;

  function ensureModelViewer() {
    if (mvReady) return mvReady;
    mvReady = new Promise(function (resolve, reject) {
      function doInject() {
        if (customElements.get("model-viewer")) {
          resolve();
          return;
        }
        var mvSrc =
          getAssets().modelViewer; /* fresh #cb-assets read (item 6) */
        if (!mvSrc) {
          reject(
            new Error("cb-mv-nosrc"),
          ); /* no vendored module → spin scrub */
          return;
        }
        var s = document.createElement("script");
        s.type = "module";
        s.src =
          mvSrc; /* vendored Shopify asset URL from #cb-assets (not a CDN) */
        s.onerror = function () {
          reject(
            new Error("cb-mv-onerror"),
          ); /* offline / asset 404 → spin scrub */
        };
        document.head.appendChild(s);
        /* a hung or blocked module fires no error event — hard timeout so the
                 viewers never stay invisible forever */
        var mvTimeout = setTimeout(function () {
          if (!customElements.get("model-viewer"))
            reject(new Error("cb-mv-timeout"));
        }, 10000);
        customElements
          .whenDefined("model-viewer")
          .then(function () {
            clearTimeout(mvTimeout);
            resolve();
          })
          .catch(function () {
            clearTimeout(mvTimeout);
            reject(new Error("cb-mv-whendefined"));
          });
      }
      /* injected on idle AFTER window load — never render-blocking */
      if (document.readyState === "complete") idle(doInject, 2500);
      else
        window.addEventListener("load", function () {
          idle(doInject, 2500);
        });
    });
    return mvReady;
  }

  /* ================= constellation points canvas (the ONE canvas) ================= */
  function sky() {
    var canvas = document.getElementById("cb-sky");
    var hero = document.getElementById("cb-hero");
    if (!canvas || !hero || !canvas.getContext) return;
    var ctx = canvas.getContext("2d");
    if (!ctx) return;
    /* Save-Data / low-memory: skip the animated points canvas entirely —
             the static nebula poster carries the hero (S7) */
    if (SAVE || LOWMEM) return;

    /* HARDENING (Marcus): idempotent per-canvas guard. A theme-editor
             section reload swaps #cb-sky for a FRESH node (no flag → re-inits);
             re-invoking sky() on the SAME canvas no-ops. Combined with play()'s
             single-rAF guard, only ONE animation loop / 2D context ever exists,
             even across section reloads. */
    if (canvas.dataset.cbSkyInit) return;
    canvas.dataset.cbSkyInit = "1";

    var N = SMALL
      ? 260
      : 900; /* PERF: mobile trimmed 450→260 to cut canvas TBT; desktop full 900 */
    var DPR = Math.min(window.devicePixelRatio || 1, SMALL ? 1.5 : 2);
    var W = 0,
      H = 0;
    var pts = null; /* free-flowing scatter field — silhouette morphs REMOVED
                       (owner 2026-07-06: no star squares, ever) */
    var theta = 0;
    var raf = 0,
      visible = false,
      started = false;
    /* Procedural orbit rings (owner 2026-07-06 v4). Rotating the flat nebula
       POSTER required a ~1.9× cover crop that read as a zoom-in ("Nebula is
       spinning but it's zooming in — that's a problem"), so the poster is
       fully static again — zero transforms, original framing, LCP untouched.
       The visible "sky is turning" cue now comes from these canvas rings:
       thin gold ellipses around the star anchor whose bright comet segments
       and orbit dust advance with the SAME theta as the stars (so the launch
       surge sweeps them faster for free). Ellipses only — never a rectangle
       (owner: no star squares, ever). Geometry is precomputed in size();
       dust/comet seeds are generated once — zero per-frame allocations. */
    var RING_P = [
      { k: 0.55, e: 0.34, tilt: -0.42, a: 0.16, lw: 0.8, comets: 2, dust: 16 },
      { k: 0.8, e: 0.4, tilt: -0.38, a: 0.14, lw: 1.0, comets: 1, dust: 18 },
      { k: 1.05, e: 0.45, tilt: -0.46, a: 0.12, lw: 1.2, comets: 1, dust: 20 },
    ];
    var RING_COMET_RATE = 3; /* comet heads sweep at theta×3 (≈2.7°/s idle) —
                                unmistakably moving within a few seconds,
                                still calm; dust rides theta×1 with the stars */
    var ringGeo = null; /* pixel geometry, rebuilt in size() */
    var ringSeed = null; /* comet offsets + dust angles, generated once */

    /* ---- rocket launch state (John 2026-07-06) ----------------------------
       Hold-to-charge → diagonal bottom-left→top-right lift-off → embers
       absorbed into the constellation → pack returns to the pad. Everything
       renders in THIS canvas + loop (no second context); the pack itself is a
       DOM img moved by transform only (zero layout / zero CLS). Never inits
       on RM (initLaunch guards) and never exists on SAVE/LOWMEM (sky() has
       already returned above, so the pad button stays disabled and the
       Ignite control remains a plain #lineup anchor). */
    var lNodes = null; /* set by initLaunch(); null = launch inactive */
    var lCleanup = null;
    var lState = "rest"; /* rest | charging | flight | gone | returning */
    var lThetaVel = 0; /* extra sky rotation in rad/ms (charge ramp + kick) */
    var lCharge = 0,
      lHoldStart = 0,
      lCooldownUntil = 0;
    var lFlightT = 0,
      lFlightDur = 1750,
      lReturnT = 0,
      lGoneAt = 0,
      lBobT = 0,
      lEmitAcc = 0;
    var lRest =
      null; /* {x,y,w} pack centre in hero coords (measured on demand) */
    var lWave = { on: false, t: 0, x: 0, y: 0 };
    var lWaveR = 0,
      lWaveA = 0;
    var lBloom = { on: false, t: 0, x: 0, y: 0 };
    var lShake = 0;
    var lPointerX = 0.5;
    var lEmbers = null,
      lSprGold = null,
      lSprHot = null,
      lLive = 0;
    var lLastRot = 0; /* agy P2: reuse when path samples coincide (flight end) */
    /* Sky-rotation tunables (owner directive 2026-07-06): the constellation
       drifts CONSTANTLY at a slow premium rate; the charge ramp (≈×8 total)
       and the launch kick stack ON TOP of the drift and decay back to it —
       never to zero. All rad/ms; same per-point cos/sin already in the loop,
       zero extra allocations. RM never runs the loop (static sky);
       SAVE/LOWMEM have no canvas at all. */
    var LTHETA_IDLE =
      (((SMALL ? 0.7 : 0.9) * Math.PI) / 180) *
      0.001; /* 0.9°/s desktop · 0.7°/s mobile */
    var LTHETA_CHARGE = LTHETA_IDLE * 7; /* extra while holding ⇒ ≈×8 total */
    var LTHETA_KICK = LTHETA_IDLE * 5; /* launch surge, ×(0.6–1.4) by power */
    var LSTREAK_MIN =
      LTHETA_CHARGE *
      1.15; /* streaks ONLY on the launch surge — dots during idle drift
               (extra spin = 0) and during the charge ramp */

    function easeOutExpo(t) {
      return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t);
    }
    function launchHot() {
      return !!(
        lNodes &&
        (lState !== "rest" || lLive > 0 || lWave.on || lBloom.on || lShake > 0)
      );
    }

    function size() {
      var r = hero.getBoundingClientRect();
      W = Math.max(1, Math.round(r.width));
      H = Math.max(1, Math.round(r.height));
      canvas.width = Math.round(W * DPR);
      canvas.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      /* orbit-ring pixel geometry (seeds stay stable across resizes) */
      seedRings();
      var base = Math.min(W, H);
      ringGeo = [];
      for (var gi = 0; gi < RING_P.length; gi++) {
        var rp = RING_P[gi];
        ringGeo.push({
          rx: base * rp.k,
          ry: base * rp.k * rp.e,
          tilt: rp.tilt,
          a: rp.a,
          lw: rp.lw,
        });
      }
    }
    /* one-time comet/dust seeds — angles fixed, motion comes from theta */
    function seedRings() {
      if (ringSeed) return;
      ringSeed = [];
      for (var gi = 0; gi < RING_P.length; gi++) {
        var rp = RING_P[gi];
        var comets = [];
        for (var ci = 0; ci < rp.comets; ci++)
          comets.push(Math.random() * Math.PI * 2);
        var dust = [];
        for (var di = 0; di < rp.dust; di++)
          dust.push({
            ang: Math.random() * Math.PI * 2,
            r: 0.6 + Math.random() * 1.1,
            a: 0.25 + Math.random() * 0.45,
            dp: Math.random() * Math.PI * 2,
          });
        ringSeed.push({ comets: comets, dust: dust });
      }
    }
    /* rotating orbit rings — drawn every frame around the star anchor.
       Base ellipse is a faint constant stroke; the comet segments (theta×3)
       and dust (theta×1, twinkling like the stars) carry the visible motion. */
    function drawRings(ts, cx, cy) {
      if (!ringGeo || !ringSeed) return;
      ctx.strokeStyle = "#f9c558";
      ctx.fillStyle = "#f9c558";
      for (var gi = 0; gi < ringGeo.length; gi++) {
        var rg = ringGeo[gi];
        var rs = ringSeed[gi];
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(rg.tilt);
        ctx.globalAlpha = rg.a;
        ctx.lineWidth = rg.lw;
        ctx.beginPath();
        ctx.ellipse(0, 0, rg.rx, rg.ry, 0, 0, 6.2832);
        ctx.stroke();
        /* comet heads + 3-segment falloff tail */
        for (var ci = 0; ci < rs.comets.length; ci++) {
          var head = rs.comets[ci] + theta * RING_COMET_RATE;
          for (var seg = 0; seg < 4; seg++) {
            ctx.globalAlpha = 0.5 * (1 - seg * 0.24);
            ctx.lineWidth = rg.lw + 0.9 - seg * 0.18;
            ctx.beginPath();
            ctx.ellipse(
              0,
              0,
              rg.rx,
              rg.ry,
              0,
              head - (seg + 1) * 0.09,
              head - seg * 0.09,
            );
            ctx.stroke();
          }
        }
        /* orbit dust rides the same theta as the stars */
        for (var di = 0; di < rs.dust.length; di++) {
          var dd = rs.dust[di];
          var ang = dd.ang + theta;
          ctx.globalAlpha =
            dd.a * (0.55 + 0.45 * Math.sin(dd.dp + ts * 0.0009));
          ctx.beginPath();
          ctx.arc(
            Math.cos(ang) * rg.rx,
            Math.sin(ang) * rg.ry,
            dd.r,
            0,
            6.2832,
          );
          ctx.fill();
        }
        ctx.restore();
      }
      ctx.globalAlpha = 1;
    }

    /* free-flowing scatter field (owner 2026-07-06: silhouette morphs
       REMOVED — no box/stick/tab star outlines, ever). 62% of the points
       ride a loose band along the nebula's bottom-left→top-right grain,
       the rest fill the sky; the whole field just drifts and rotates. */
    function scatterPoints() {
      var out = [];
      for (var i = 0; i < N; i++) {
        var x, y;
        if (i < N * 0.62) {
          /* diagonal band in unit space, gaussian-ish spread via CLT */
          var t = Math.random();
          var spread =
            (Math.random() + Math.random() + Math.random() - 1.5) * 0.42;
          x = (t - 0.5) * 1.7 + spread * 0.35;
          y = (0.5 - t) * 1.1 + spread;
        } else {
          x = (Math.random() - 0.5) * 2.2;
          y = (Math.random() - 0.5) * 1.6;
        }
        out.push({
          x: x,
          y: y,
          r: 0.6 + Math.random() * 1.4,
          a: 0.35 + Math.random() * 0.55,
          dp: Math.random() * Math.PI * 2 /* drift phase */,
        });
      }
      return out;
    }
    function seedPoints() {
      if (!pts) pts = scatterPoints();
    }

    var last = 0,
      lastDraw = 0,
      FPS_MS = SMALL
        ? 30
        : 0; /* PERF: ~30fps cap on mobile to halve main-thread canvas cost (dt-based motion stays consistent) */
    function frame(ts) {
      /* HARDENING (Marcus, item 2): detached-node kill-switch. A theme-editor
               reload swaps #cb-sky for a fresh node; the OLD node's closure must
               not keep a 60fps rAF loop running forever. If our canvas is no
               longer in the document, stop rescheduling and let this ghost die. */
      if (!canvas || !canvas.isConnected) {
        raf = 0;
        return;
      }
      raf = 0;
      if (!visible || document.hidden) return;
      /* the mobile fps cap lifts ONLY while a launch is hot (~2s window) so
         the flying pack + exhaust stay smooth; idle cost is unchanged */
      if (FPS_MS && lastDraw && ts - lastDraw < FPS_MS && !launchHot()) {
        raf = requestAnimationFrame(frame);
        return;
      }
      lastDraw = ts;
      if (!last) last = ts;
      var dt = Math.min(48, ts - last);
      last = ts;
      theta += dt * LTHETA_IDLE; /* constant premium drift (owner 2026-07-06) */
      if (lThetaVel) {
        /* reactive sky: extra spin from charge/launch, decaying ~1.2s.
           Additive on theta. */
        theta += lThetaVel * dt;
        lThetaVel *= Math.pow(0.9985, dt);
        if (lThetaVel < 0.0000005) lThetaVel = 0;
      }
      /* shockwave front for this frame (star displacement is additive on the
         projected positions — the base field is never mutated) */
      lWaveR = 0;
      lWaveA = 0;
      if (lWave.on) {
        lWave.t += dt / 700;
        if (lWave.t >= 1) lWave.on = false;
        else {
          lWaveR = easeOutExpo(lWave.t) * Math.max(W, H) * 0.55;
          lWaveA = 1 - lWave.t;
        }
      }

      ctx.clearRect(0, 0, W, H);
      /* constellation sits behind the right-hand stage */
      var cx = SMALL ? W * 0.5 : W * 0.7;
      var cy = SMALL ? H * 0.62 : H * 0.52;
      var S = Math.min(W, H) * (SMALL ? 0.9 : 1.05);
      drawRings(ts, cx, cy); /* rotating orbit rings — under the stars */
      var cosT = Math.cos(theta),
        sinT = Math.sin(theta);
      var streaks = lThetaVel > LSTREAK_MIN;
      ctx.fillStyle = "#f5a500";
      if (streaks) {
        ctx.strokeStyle = "#f5a500";
        ctx.lineCap = "round";
      }
      seedPoints();
      for (var i = 0; i < N; i++) {
        var pb = pts[i];
        var px = pb.x;
        var py = pb.y;
        /* subtle per-point drift (position, not opacity) */
        var d = Math.sin(ts * 0.0004 + pb.dp) * 0.004;
        px += d;
        py -= d;
        var rx = px * cosT - py * sinT;
        var ry = px * sinT + py * cosT;
        var sx = cx + rx * S;
        var sy = cy + ry * S;
        if (lWaveA > 0) {
          /* radial push, gaussian around the wavefront — additive offset */
          var dwx = sx - lWave.x,
            dwy = sy - lWave.y;
          var dw = Math.sqrt(dwx * dwx + dwy * dwy) || 1;
          var g = Math.exp((-(dw - lWaveR) * (dw - lWaveR)) / 7200);
          sx += (dwx / dw) * g * 20 * lWaveA;
          sy += (dwy / dw) * g * 20 * lWaveA;
        }
        ctx.globalAlpha = pb.a;
        if (streaks) {
          /* launch surge: stars elongate into short tangential arcs */
          var trx = -ry,
            trY = rx;
          var tl = Math.sqrt(trx * trx + trY * trY) || 1;
          var rlenPx = tl * S;
          var slen = Math.min(14, lThetaVel * 1000 * rlenPx * 0.3);
          if (slen < 1) slen = 1;
          ctx.lineWidth = pb.r;
          ctx.beginPath();
          ctx.moveTo(sx, sy);
          ctx.lineTo(sx + (trx / tl) * slen, sy + (trY / tl) * slen);
          ctx.stroke();
        } else {
          ctx.beginPath();
          ctx.arc(sx, sy, pb.r, 0, 6.2832);
          ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
      if (lNodes) drawLaunch(ts, dt, cx, cy);
      raf = requestAnimationFrame(frame);
    }

    function play() {
      if (RM) {
        /* reduced-motion: one static frame, no loop */
        if (!started) {
          started = true;
          size();
          seedPoints();
          visible = true;
          requestAnimationFrame(function (ts) {
            var keep = visible;
            frame(ts);
            visible = keep;
            if (raf) {
              cancelAnimationFrame(raf);
              raf = 0;
            }
          });
        }
        return;
      }
      if (!raf) {
        last = 0;
        raf = requestAnimationFrame(frame);
      }
    }
    function pause() {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = 0;
      }
    }

    /* ================= rocket launch (John 2026-07-06) =================
       Pooled gold-ember exhaust on THIS canvas + a DOM pack actor flown by
       transform along a bottom-left→top-right ballistic arc. Hold to charge,
       release (or quick tap) for lift-off. */
    function lSprite(rgb, rad) {
      var c = document.createElement("canvas");
      c.width = c.height = rad * 2;
      var g = c.getContext("2d");
      if (!g) return null;
      var grad = g.createRadialGradient(rad, rad, 0, rad, rad, rad);
      grad.addColorStop(0, "rgba(" + rgb + ",0.9)");
      grad.addColorStop(0.35, "rgba(" + rgb + ",0.45)");
      grad.addColorStop(1, "rgba(" + rgb + ",0)");
      g.fillStyle = grad;
      g.fillRect(0, 0, rad * 2, rad * 2);
      return c;
    }
    function lInitPool() {
      var POOL = SMALL ? 220 : 420;
      lEmbers = new Array(POOL);
      for (var i = 0; i < POOL; i++)
        lEmbers[i] = {
          on: false,
          x: 0,
          y: 0,
          vx: 0,
          vy: 0,
          life: 0,
          max: 1,
          r: 1,
          hot: false,
        };
      lSprGold = lSprite("245,165,0", 16);
      lSprHot = lSprite("255,243,208", 10);
      lLive = 0;
    }
    function lEmit(x, y, dirX, dirY, spread, speed, n, hotChance) {
      if (!lEmbers) return;
      for (var k = 0; k < lEmbers.length && n > 0; k++) {
        var p = lEmbers[k];
        if (p.on) continue;
        n--;
        var a = Math.atan2(dirY, dirX) + (Math.random() - 0.5) * spread;
        var v = speed * (0.5 + Math.random() * 0.8);
        p.on = true;
        lLive++;
        p.x = x + (Math.random() - 0.5) * 14;
        p.y = y + (Math.random() - 0.5) * 8;
        p.vx = Math.cos(a) * v;
        p.vy = Math.sin(a) * v;
        p.max = 700 + Math.random() * 900; /* ms */
        p.life = p.max;
        p.hot = Math.random() < hotChance;
        p.r = (p.hot ? 0.7 : 1) * (2.2 + Math.random() * 3.4);
      }
    }
    function lMeasureRest() {
      var hr = hero.getBoundingClientRect();
      var pr = lNodes.restEl.getBoundingClientRect();
      /* the rocket SVG is a 200×400 viewBox — tall 1:2 box, so track both
         dimensions; NOZZLE sits at ~0.74 of the height (offset 0.24·h from
         centre) — that's where the exhaust emits */
      lRest = {
        x: pr.left - hr.left + pr.width / 2,
        y: pr.top - hr.top + pr.height / 2,
        w: pr.width,
        h: pr.height,
      };
    }
    function lPlaceActor(x, y, rot, scale) {
      var w = lRest.w,
        h = lRest.h;
      lNodes.actor.style.width = w + "px";
      lNodes.actor.style.height = h + "px";
      lNodes.actor.style.transform =
        "translate3d(" +
        (x - w / 2).toFixed(1) +
        "px," +
        (y - h / 2).toFixed(1) +
        "px,0) rotate(" +
        rot.toFixed(1) +
        "deg) scale(" +
        scale.toFixed(3) +
        ")";
    }
    function lQbez(p0, p1, p2, t) {
      var u = 1 - t;
      return {
        x: u * u * p0.x + 2 * u * t * p1.x + t * t * p2.x,
        y: u * u * p0.y + 2 * u * t * p1.y + t * t * p2.y,
      };
    }
    function lPathPoint(tt) {
      /* bottom-left swoosh (~240ms) then the ballistic ascent to top-right —
         flying the nebula band's own grain. Ascent easing keeps velocity
         through the corner (0.22·t + 0.78·t³): no visible dwell at the rail. */
      var swooshFrac = 240 / lFlightDur;
      var P0 = { x: lRest.x, y: lRest.y };
      var PL = {
        x: W * (SMALL ? 0.18 : 0.14),
        y: H * (SMALL ? 0.9 : 0.88),
      };
      var C0 = { x: lRest.x - W * 0.14, y: lRest.y + H * 0.18 };
      var PE = {
        x: W * (SMALL ? 1.05 : 1.1),
        y: -H * (SMALL ? 0.15 : 0.18),
      };
      var C1 = {
        x: W * (SMALL ? 0.68 : 0.7),
        y: H * (SMALL ? 0.92 : 0.95),
      };
      var p, q;
      if (tt < swooshFrac) {
        var t1 = tt / swooshFrac;
        p = lQbez(P0, C0, PL, t1);
        q = lQbez(P0, C0, PL, Math.min(1, t1 + 0.02));
      } else {
        var t0 = (tt - swooshFrac) / (1 - swooshFrac);
        var t2 = 0.22 * t0 + 0.78 * t0 * t0 * t0;
        var t0b = Math.min(1, t0 + 0.015);
        var t2b = 0.22 * t0b + 0.78 * t0b * t0b * t0b;
        p = lQbez(PL, C1, PE, t2);
        q = lQbez(PL, C1, PE, t2b);
      }
      /* agy P2: at tt=1 the two samples coincide → atan2(0,0) would snap the
         rotation to 90° on the final frame; reuse the previous tangent. */
      var rdx = q.x - p.x,
        rdy = q.y - p.y;
      var rot;
      if (Math.abs(rdx) < 1e-6 && Math.abs(rdy) < 1e-6) rot = lLastRot;
      else {
        rot = Math.atan2(rdy, rdx) * 57.29578 + 90;
        lLastRot = rot;
      }
      return { x: p.x, y: p.y, rot: rot };
    }
    function lGlowSet(el, opacity, scale) {
      /* engine-glow ellipse (cx 100, cy 300 in viewBox units) — opacity plus
         a slight rx/ry swell; attribute writes, no allocations */
      if (!el) return;
      el.setAttribute("opacity", opacity.toFixed(3));
      el.setAttribute("rx", (26 * scale).toFixed(1));
      el.setAttribute("ry", (14 * scale).toFixed(1));
    }
    function lLiftoff(power) {
      if (!lNodes || !lRest) return;
      lState = "flight";
      lFlightT = 0;
      lFlightDur = (SMALL ? 1150 : 1750) * (1.1 - power * 0.2);
      lNodes.restEl.style.transform = "";
      lNodes.packRest.style.visibility = "hidden";
      lNodes.actor.hidden = false;
      lGlowSet(lNodes.glowFly, 1, 1.35); /* engines at full in flight */
      lPlaceActor(lRest.x, lRest.y, 0, 1);
      var bx = lRest.x,
        by = lRest.y + lRest.h * 0.24; /* the NOZZLE, not the box base */
      lBloom.on = true;
      lBloom.t = 0;
      lBloom.x = bx;
      lBloom.y = by;
      lWave.on = true;
      lWave.t = 0;
      lWave.x = bx;
      lWave.y = by;
      lShake = 1;
      if (lNodes.fuse) lNodes.fuse.style.width = "0%";
      lEmit(bx, by, 0, 1, 2.4, 5.5 * power + 2, SMALL ? 44 : 90, 0.35);
      lThetaVel += LTHETA_KICK * (0.6 + 0.8 * power);
      if (navigator.vibrate) {
        try {
          navigator.vibrate([15, 40, 15]);
        } catch (err) {}
      }
    }
    function drawLaunch(ts, dt, cx, cy) {
      /* ---- rocket state machine (DOM transforms only) ---- */
      if (lState === "rest") {
        lBobT += dt;
        var bob = Math.sin(lBobT * 0.00105) * 6;
        lNodes.restEl.style.transform =
          "translate3d(0," + bob.toFixed(2) + "px,0)";
        /* idle engine pulse: soft 0.35–0.6 sine on the pad glow */
        lGlowSet(lNodes.glowPad, 0.475 + 0.125 * Math.sin(ts * 0.0012), 1);
        /* pilot embers rising from the nozzle, leaning away from the cursor */
        lEmitAcc += dt * (SMALL ? 0.0015 : 0.0025);
        if (lEmitAcc >= 1) {
          lEmitAcc = 0;
          if (!lRest) lMeasureRest();
          var lean = (lPointerX - 0.5) * -1.4;
          lEmit(
            lRest.x,
            lRest.y + bob + lRest.h * 0.24,
            lean,
            1,
            0.9,
            1.1,
            1,
            0,
          );
        }
      } else if (lState === "charging") {
        lCharge = Math.min(1, lCharge + dt / 1200);
        if (lNodes.fuse)
          lNodes.fuse.style.width = (lCharge * 100).toFixed(1) + "%";
        var j = 1.5 + lCharge * 1.5;
        lNodes.restEl.style.transform =
          "translate3d(" +
          ((Math.random() - 0.5) * j).toFixed(2) +
          "px," +
          (6 + (Math.random() - 0.5) * j).toFixed(2) +
          "px,0)";
        /* engine glow brightens + swells with the charge */
        lGlowSet(lNodes.glowPad, 0.6 + 0.4 * lCharge, 1 + 0.35 * lCharge);
        if (lThetaVel < LTHETA_CHARGE * lCharge)
          lThetaVel = LTHETA_CHARGE * lCharge;
        lEmitAcc += dt * (0.006 + lCharge * (SMALL ? 0.044 : 0.054));
        while (lEmitAcc >= 1) {
          lEmitAcc -= 1;
          lEmit(
            lRest.x,
            lRest.y + lRest.h * 0.24,
            0,
            1,
            1.4,
            2.4 + lCharge * 2.4,
            1,
            lCharge > 0.5 ? 0.5 : 0,
          );
        }
        if (lCharge >= 1) lLiftoff(1); /* full charge auto-launches */
      } else if (lState === "flight") {
        lFlightT += dt / lFlightDur;
        var tt = Math.min(1, lFlightT);
        var p = lPathPoint(tt);
        var sc = SMALL ? 1 - tt * 0.45 : 1 - tt * 0.15;
        lPlaceActor(p.x, p.y, p.rot, sc);
        var pn = lPathPoint(Math.max(0, tt - 0.02));
        var fdx = p.x - pn.x,
          fdy = p.y - pn.y;
        var fdl = Math.sqrt(fdx * fdx + fdy * fdy) || 1;
        lEmitAcc += dt * (SMALL ? 0.07 : 0.13);
        while (lEmitAcc >= 1) {
          lEmitAcc -= 1;
          /* plume from the NOZZLE: trail the rocket along -travel by ~0.30·h */
          lEmit(
            p.x - (fdx / fdl) * lRest.h * 0.3,
            p.y - (fdy / fdl) * lRest.h * 0.3,
            -fdx / fdl,
            -fdy / fdl,
            0.7,
            4.6,
            1,
            0.4,
          );
        }
        if (tt >= 1) {
          lState = "gone";
          lGoneAt = ts;
          lNodes.actor.hidden = true;
          if (lNodes.stars) {
            lNodes.stars.hidden = false;
            requestAnimationFrame(function () {
              if (lNodes && lNodes.stars) lNodes.stars.classList.add("is-on");
            });
          }
        }
      } else if (lState === "gone") {
        if (ts - lGoneAt > 1400) {
          lState = "returning";
          lReturnT = 0;
          lNodes.packRest.style.visibility = "";
          lNodes.restEl.style.opacity = "0";
        }
      } else if (lState === "returning") {
        lReturnT += dt / 700;
        var rt = Math.min(1, lReturnT);
        var er = easeOutExpo(rt);
        lNodes.restEl.style.transform =
          "translate3d(0," +
          (-(1 - er) * 60).toFixed(1) +
          "px,0) scale(" +
          (0.92 + er * 0.08).toFixed(3) +
          ")";
        lNodes.restEl.style.opacity = rt.toFixed(2);
        if (rt >= 1) {
          lState = "rest";
          lBobT = 0;
          lNodes.restEl.style.opacity = "";
          lCooldownUntil = ts + 1200;
          if (lNodes.stars) {
            lNodes.stars.classList.remove("is-on");
            var starsEl = lNodes.stars;
            setTimeout(function () {
              if (!starsEl.classList.contains("is-on")) starsEl.hidden = true;
            }, 650);
          }
          if (lRest)
            lEmit(lRest.x, lRest.y + lRest.h * 0.24, 0, 1, 2.8, 1.6, 10, 0);
        }
      }

      /* ---- exhaust / bloom / shockwave ring (additive, launch window only) ---- */
      if (lLive > 0 || lBloom.on || lWaveA > 0) {
        ctx.globalCompositeOperation = "lighter";
        for (var k2 = 0; k2 < lEmbers.length; k2++) {
          var e2 = lEmbers[k2];
          if (!e2.on) continue;
          e2.life -= dt;
          if (e2.life <= 0) {
            e2.on = false;
            lLive--;
            continue;
          }
          e2.x += e2.vx * (dt / 16.7);
          e2.y += e2.vy * (dt / 16.7);
          var drag = Math.pow(0.965, dt / 16.7);
          e2.vx *= drag;
          e2.vy *= drag;
          var age = 1 - e2.life / e2.max;
          if (age > 0.55) {
            /* late life: absorbed toward the constellation centre */
            var ax = cx - e2.x,
              ay = cy - e2.y;
            var al = Math.sqrt(ax * ax + ay * ay) || 1;
            e2.vx += (ax / al) * 0.045 * (dt / 16.7);
            e2.vy += (ay / al) * 0.045 * (dt / 16.7);
          }
          var la = Math.min(1, (e2.life / e2.max) * 1.6);
          var spr = e2.hot && age < 0.35 ? lSprHot : lSprGold;
          if (!spr) continue;
          var rr = e2.r * (1 - age * 0.55);
          ctx.globalAlpha = la;
          ctx.drawImage(spr, e2.x - rr, e2.y - rr, rr * 2, rr * 2);
        }
        if (lBloom.on) {
          lBloom.t += dt / 500;
          if (lBloom.t >= 1) lBloom.on = false;
          else {
            var bt = lBloom.t;
            var ba = bt < 0.24 ? bt / 0.24 : 1 - (bt - 0.24) / 0.76;
            var br = 40 + bt * 180;
            var bg = ctx.createRadialGradient(
              lBloom.x,
              lBloom.y,
              0,
              lBloom.x,
              lBloom.y,
              br,
            );
            bg.addColorStop(
              0,
              "rgba(255,243,208," + (0.8 * ba).toFixed(3) + ")",
            );
            bg.addColorStop(
              0.4,
              "rgba(245,165,0," + (0.4 * ba).toFixed(3) + ")",
            );
            bg.addColorStop(1, "rgba(245,165,0,0)");
            ctx.fillStyle = bg;
            ctx.beginPath();
            ctx.arc(lBloom.x, lBloom.y, br, 0, 6.2832);
            ctx.fill();
          }
        }
        if (lWaveA > 0) {
          ctx.strokeStyle =
            "rgba(249,197,88," + (0.65 * lWaveA).toFixed(3) + ")";
          ctx.lineWidth = 2 * lWaveA + 0.25;
          ctx.beginPath();
          ctx.arc(lWave.x, lWave.y, lWaveR, 0, 6.2832);
          ctx.stroke();
        }
        ctx.globalCompositeOperation = "source-over";
        ctx.globalAlpha = 1;
        ctx.fillStyle =
          "#f5a500"; /* restore the star fill for the next frame */
      }

      /* ---- screen shake: transform-only, copy + stage columns, never the
             nebula poster (the still background reads as depth) ---- */
      if (lShake > 0) {
        lShake = Math.max(0, lShake - dt / 400);
        var amp = (SMALL ? 2 : 3) * lShake;
        var shx = (Math.random() - 0.5) * 2 * amp;
        var shy = (Math.random() - 0.5) * 2 * amp;
        if (lNodes.copyCol)
          lNodes.copyCol.style.transform = lShake
            ? "translate3d(" + shx.toFixed(1) + "px," + shy.toFixed(1) + "px,0)"
            : "";
        if (lNodes.stageCol)
          lNodes.stageCol.style.transform = lShake
            ? "translate3d(" +
              (-shx * 0.6).toFixed(1) +
              "px," +
              (-shy * 0.6).toFixed(1) +
              "px,0)"
            : "";
      }
    }
    function initLaunch() {
      if (RM) return; /* reduced motion: static rocket, no launch system */
      var layer = document.getElementById("cb-launch-layer");
      var actor = document.getElementById("cb-launch-actor");
      var packRest = document.getElementById("cb-pack-rest");
      var igniteEl = document.getElementById("cb-ignite");
      if (!layer || !actor || !packRest || !igniteEl) return;
      if (layer.dataset.cbLaunchInit) return;
      layer.dataset.cbLaunchInit = "1";
      var restEl = packRest.querySelector("svg"); /* the resting rocket SVG */
      if (!restEl) return;
      lNodes = {
        layer: layer,
        actor: actor,
        packRest: packRest,
        restEl: restEl,
        glowPad: document.getElementById("cb-rkt-glow-pad"),
        glowFly: document.getElementById("cb-rkt-glow-fly"),
        ignite: igniteEl,
        fuse: igniteEl.querySelector(".cb-c8-ignite__fuse"),
        hint: document.getElementById("cb-hero-hint"),
        stars: document.getElementById("cb-amongstars"),
        copyCol: hero.querySelector(".cb-c8-hero__copy"),
        stageCol: hero.querySelector(".cb-c8-hero__stagecol"),
      };
      lInitPool();
      packRest.disabled = false;
      igniteEl.classList.add("is-armed");
      igniteEl.setAttribute("role", "button");
      igniteEl.setAttribute(
        "aria-label",
        "Launch the rocket — decorative animation. Hold to charge, release for lift-off.",
      );
      if (lNodes.hint) lNodes.hint.hidden = false;
      function startCharge(e) {
        if (!lNodes || lState !== "rest") return;
        var now = performance.now();
        if (now < lCooldownUntil) return;
        /* agy P2: unconditional — blocks native image drag/text selection
           from hijacking the hold gesture (touch scroll is governed by
           touch-action, not this). */
        if (e && e.preventDefault) e.preventDefault();
        lMeasureRest();
        lCharge = 0;
        lHoldStart = now;
        lState = "charging";
      }
      function release() {
        if (!lNodes || lState !== "charging") return;
        var held = performance.now() - lHoldStart;
        lLiftoff(held < 200 ? 0.6 : Math.min(1, 0.45 + lCharge * 0.55));
      }
      function cancelCharge() {
        /* Codex P2: pointercancel (e.g. the gesture handed to page scroll),
           tab switch, or window blur must NEVER launch — reset to rest. */
        if (!lNodes || lState !== "charging") return;
        lState = "rest";
        lCharge = 0;
        lBobT = 0;
        if (lNodes.fuse) lNodes.fuse.style.width = "0%";
        lNodes.restEl.style.transform = "";
        lGlowSet(lNodes.glowPad, 0.55, 1); /* engine back to idle pulse */
      }
      function onHiddenCancel() {
        if (document.hidden) cancelCharge();
      }
      function onKey(e) {
        if (!lNodes || lState !== "rest") return;
        if (e.key !== "Enter" && e.key !== " ") return;
        if (performance.now() < lCooldownUntil) return;
        e.preventDefault();
        lMeasureRest();
        lLiftoff(0.8);
      }
      function onIgniteClick(e) {
        /* armed: the pointer handlers own the interaction — never navigate */
        e.preventDefault();
      }
      function onPointerMove(e) {
        var r = hero.getBoundingClientRect();
        lPointerX = r.width ? (e.clientX - r.left) / r.width : 0.5;
      }
      packRest.addEventListener("pointerdown", startCharge);
      igniteEl.addEventListener("pointerdown", startCharge);
      igniteEl.addEventListener("click", onIgniteClick);
      window.addEventListener("pointerup", release);
      window.addEventListener(
        "pointercancel",
        cancelCharge,
      ); /* Codex P2: cancel, never launch */
      document.addEventListener("visibilitychange", onHiddenCancel);
      window.addEventListener("pagehide", cancelCharge);
      window.addEventListener("blur", cancelCharge);
      packRest.addEventListener("keydown", onKey);
      igniteEl.addEventListener("keydown", onKey);
      hero.addEventListener("pointermove", onPointerMove, { passive: true });
      lCleanup = function () {
        window.removeEventListener("pointerup", release);
        window.removeEventListener("pointercancel", cancelCharge);
        document.removeEventListener("visibilitychange", onHiddenCancel);
        window.removeEventListener("pagehide", cancelCharge);
        window.removeEventListener("blur", cancelCharge);
        packRest.removeEventListener("pointerdown", startCharge);
        igniteEl.removeEventListener("pointerdown", startCharge);
        igniteEl.removeEventListener("click", onIgniteClick);
        packRest.removeEventListener("keydown", onKey);
        igniteEl.removeEventListener("keydown", onKey);
        hero.removeEventListener("pointermove", onPointerMove);
        if (lNodes) {
          if (lNodes.copyCol) lNodes.copyCol.style.transform = "";
          if (lNodes.stageCol) lNodes.stageCol.style.transform = "";
          lNodes.packRest.style.visibility = "";
          lNodes.restEl.style.transform = "";
          lNodes.restEl.style.opacity = "";
          lGlowSet(lNodes.glowPad, 0.55, 1);
          lNodes.actor.hidden = true;
        }
        lNodes = null;
        lState = "rest";
        lShake = 0;
        lWave.on = false;
        lBloom.on = false;
        lLive = 0;
      };
    }

    function boot() {
      if (!canvas || !canvas.isConnected)
        return; /* HARDENING: deferred boot (idle) on a section already unloaded in the editor — no-op so we never wire a detached canvas */
      size();
      seedPoints(); /* free scatter field — silhouette morphs removed (owner 2026-07-06) */
      initLaunch(); /* rocket launch — no-ops on RM or when the markup is absent */

      /* HARDENING (Marcus, item 5): the primary visibility observer is now
               feature-guarded. WITH IntersectionObserver the canvas is gated to
               the hero being on-screen (zero cost below the fold); WITHOUT it we
               cannot viewport-gate, so run always-on — play()'s single-rAF guard
               still keeps it to one loop and frame()'s isConnected kill-switch
               still stops it on teardown. Never throws on engines that lack IO. */
      var io = null;
      if ("IntersectionObserver" in window) {
        io = new IntersectionObserver(
          function (es) {
            visible = es[0].isIntersecting;
            if (visible) play();
            else pause(); /* zero canvas cost below the fold */
          },
          { threshold: 0.02 },
        );
        io.observe(hero);
      } else {
        visible = true;
        play();
      }

      /* HARDENING (Marcus, item 3): NAMED handlers (so section:unload can
               removeEventListener them) each guarded with a detached-canvas
               no-op check — a listener left bound to a node that a section
               reload replaced does nothing. On the storefront canvas.isConnected
               is always true, so these guards are pure no-ops on the happy path. */
      var rT = 0;
      function onVis() {
        if (!canvas.isConnected) return;
        if (document.hidden) pause();
        else if (visible) play();
      }
      function onResize() {
        if (!canvas.isConnected) return;
        clearTimeout(rT);
        rT = setTimeout(size, 180);
      }
      /* Silhouette-morph triggers REMOVED (owner 2026-07-06: no star squares).
         [data-const-btn] / [data-const-kind] attributes elsewhere in the
         markup are now inert — nothing listens to them. */
      document.addEventListener("visibilitychange", onVis);
      window.addEventListener("resize", onResize, { passive: true });

      /* HARDENING (Marcus, item 3): theme-editor teardown. When THIS hero's
               section unloads (scoped by its owning .shopify-section, with a
               detached-canvas fallback for non-section-wrapped heroes), cancel
               the rAF, disconnect the visibility observer, and remove the two
               global listeners — so a reload leaves behind no zombie loop,
               observer, or handler. Fires only in the theme editor; the event
               never fires on the storefront, so this is inert for real visitors. */
      var section = (hero.closest && hero.closest(".shopify-section")) || null;
      function teardown(e) {
        var mine =
          !canvas.isConnected ||
          (e &&
            e.target &&
            section &&
            (e.target === section || e.target.contains(hero)));
        if (!mine) return;
        pause();
        if (io && io.disconnect) io.disconnect();
        document.removeEventListener("visibilitychange", onVis);
        window.removeEventListener("resize", onResize);
        if (lCleanup) {
          lCleanup(); /* rocket launch: unbind window/hero listeners + reset transforms */
          lCleanup = null;
        }
        document.removeEventListener("shopify:section:unload", teardown);
      }
      document.addEventListener("shopify:section:unload", teardown);
    }

    idle(boot, 2000); /* canvas never competes with LCP */
  }

  /* ================= true-3D ladder: model-viewer → spin scrub → poster =================
     ROCKET LAUNCH (2026-07-06): the ladder now serves the pack-3d stage ONLY.
     The hero's model-viewer + spin scrub were replaced by the launch-pad pack
     (see the launch system inside sky()); every cb-mv-hero / cb-spin-hero
     branch was removed here. cb-mv-stage / cb-spin-stage behavior unchanged. */
  function ladder() {
    /* HARDENING (Marcus, item 4): every node reference below is re-queried
             from the LIVE DOM at call time (never captured once at ladder-entry),
             so the async callbacks — whenDefined().then and the timeout/error
             fallback — always wire whatever nodes are CURRENT, even after a
             theme-editor section reload swapped them. These lookups are a
             presence check only. */
    if (
      !document.getElementById("cb-mv-stage") &&
      !document.getElementById("cb-spin-stage")
    )
      return;

    var assets =
      getAssets(); /* fresh #cb-assets read per invocation (item 6) */

    function webglOK() {
      try {
        var c = document.createElement("canvas");
        return !!(
          window.WebGLRenderingContext &&
          (c.getContext("webgl2") || c.getContext("webgl"))
        );
      } catch (e) {
        return false;
      }
    }

    /* spin-frame URL from the fresh #cb-assets map (was a hardcoded preview path) */
    function spinFrame(i) {
      var idx = ((i % 36) + 36) % 36;
      return (assets.spin && assets.spin[idx]) || "";
    }

    function initSpin(stage) {
      if (!stage || stage.dataset.spinInit) return;
      stage.dataset.spinInit = "1";
      stage.classList.add("is-active");
      var img = stage.querySelector("img");
      var frame = 0,
        dragging = false,
        lastX = 0;
      /* audit 2026-07-05: never bulk-preload 36 frames on saveData/low-memory
         devices — they are exactly who lands on this fallback. Frames still
         load on demand as the user scrubs. */
      if (!SAVE && !LOWMEM) {
        idle(function () {
          for (var i = 0; i < 36; i++) {
            var u = spinFrame(i);
            if (u) {
              var p = new Image();
              p.src = u;
            }
          }
        }, 4000);
      }
      function show(i) {
        if (stage.dataset.cbPosterLock)
          return; /* non-20g poster pinned (fallback path) */
        frame = ((i % 36) + 36) % 36;
        var u = spinFrame(frame);
        if (u && img) img.src = u;
      }
      function down(x) {
        dragging = true;
        lastX = x;
      }
      function move(x) {
        if (!dragging) return;
        var dx = x - lastX;
        if (Math.abs(dx) > 6) {
          show(frame + (dx > 0 ? 1 : -1));
          lastX = x;
        }
      }
      function up() {
        dragging = false;
      }
      /* audit item 6 (2026-07-05): keyboard operability for the spin scrub */
      stage.setAttribute("tabindex", "0");
      stage.addEventListener("keydown", function (e) {
        if (stage.dataset.cbPosterLock)
          return; /* static poster active — leave keys to the page */
        if (e.key === "ArrowLeft") {
          show(frame - 1);
          e.preventDefault();
        } else if (e.key === "ArrowRight") {
          show(frame + 1);
          e.preventDefault();
        }
      });
      stage.addEventListener("mousedown", function (e) {
        down(e.clientX);
        e.preventDefault();
      });
      window.addEventListener("mousemove", function (e) {
        move(e.clientX);
      });
      window.addEventListener("mouseup", up);
      stage.addEventListener(
        "touchstart",
        function (e) {
          down(e.touches[0].clientX);
        },
        { passive: true },
      );
      stage.addEventListener(
        "touchmove",
        function (e) {
          move(e.touches[0].clientX);
        },
        { passive: true },
      );
      stage.addEventListener("touchend", up);
    }

    function stagePosterSync(stage) {
      /* Codex P1 fix (2026-07-06): if the switcher ran while the viewer was
         alive it may have inline-hidden the spin scrub (display:none for
         non-20g picks) — initSpin's .is-active alone can't undo that, so a
         later viewer death left a BLANK stage. Re-show the scrub and pin the
         ACTIVE pack's poster, mirroring the switcher's viewer-dead branch. */
      if (!stage) return;
      stage.style.display = "";
      var btn = document.querySelector(
        '.cb-c8-mvswap button[data-cb-mv-swap][aria-pressed="true"]',
      );
      var img = stage.querySelector("img");
      if (!btn || btn.getAttribute("data-spin") === "1") {
        delete stage.dataset.cbPosterLock;
        var u = spinFrame(0);
        if (img && u) img.src = u;
        stage.setAttribute(
          "aria-label",
          "CaféBank 20 g box, drag left or right to rotate the 360° view",
        );
      } else if (img && btn.getAttribute("data-poster")) {
        stage.dataset.cbPosterLock = "1";
        img.src = btn.getAttribute("data-poster");
        stage.setAttribute(
          "aria-label",
          btn.getAttribute("data-alt") || "Product photo",
        );
      }
    }

    function toSpin() {
      /* re-query current nodes (item 4) — never stale ladder-entry captures.
         ROCKET LAUNCH (2026-07-06): stage-only — the hero has no viewer/spin. */
      var mvStage = document.getElementById("cb-mv-stage");
      var activate = document.getElementById("cb-3d-activate");
      if (mvStage && mvStage.parentNode) mvStage.remove();
      var spinStage = document.getElementById("cb-spin-stage");
      initSpin(spinStage);
      stagePosterSync(spinStage); /* Codex P1: never a blank stage */
      if (activate && !activate.dataset.cbSpin) {
        activate.dataset.cbSpin = "1";
        activate.addEventListener("click", function () {
          var t = document.getElementById("pack-3d");
          if (t) t.scrollIntoView({ block: "center" });
        });
      }
    }

    /* fall back to the spin scrub. toSpin()/initSpin() are idempotent via their
             dataset guards, and the shared mvReady promise settles once, so this
             is safe to reach from any invocation's promise callback (item 4). */
    function fallToSpin() {
      toSpin();
    }
    function wire() {
      /* re-query current nodes (item 4) so a section reload's FRESH viewers get
               wired — never the stale nodes captured at ladder-entry.
               ROCKET LAUNCH (2026-07-06): stage-only — no hero viewer branch. */
      var mvStage = document.getElementById("cb-mv-stage");
      var activate = document.getElementById("cb-3d-activate");
      /* HARDENING (Marcus): per-node guards so re-wiring fresh nodes after
               a section reload never double-binds the same element. */
      if (mvStage && !mvStage.dataset.cbWired) {
        mvStage.dataset.cbWired = "1";
        mvStage.addEventListener("error", function () {
          mvStage.remove();
          var spinStage = document.getElementById("cb-spin-stage");
          initSpin(spinStage);
          stagePosterSync(spinStage); /* Codex P1: never a blank stage */
        });
      }
      if (activate && !activate.dataset.cbMv) {
        activate.dataset.cbMv = "1";
        activate.addEventListener("click", function () {
          var t = document.getElementById("pack-3d");
          if (t) t.scrollIntoView({ block: "center" });
          /* wake the stage viewer (per the original v8 behavior) */
          try {
            var mvS = document.getElementById("cb-mv-stage");
            if (mvS && mvS.dismissPoster) mvS.dismissPoster();
          } catch (err) {}
        });
      }
    }

    /* forced spin path: saveData / low memory / no WebGL / no Custom Elements.
             HARDENING (Marcus, item 5): if customElements is absent, skip the
             model-viewer ladder entirely and go straight to the spin fallback
             instead of throwing on customElements.get / .whenDefined. */
    if (SAVE || LOWMEM || !webglOK() || !("customElements" in window)) {
      idle(toSpin, 3000);
      return;
    }

    /* HARDENING (Marcus): if model-viewer is already defined (first load
             finished, or this is a later section reload), just wire the fresh
             nodes — do NOT re-inject the module. */
    if (customElements.get("model-viewer")) {
      wire();
      return;
    }

    /* otherwise ensure the module is injected exactly once per page (via the
             shared page-level mvReady promise), and wire THIS call's current
             nodes when it defines — or fall back to spin on timeout/error.
             Because wire()/fallToSpin() re-query the DOM, a reload that lands
             while injection is still in flight still gets its fresh nodes wired
             when the shared promise settles (fixes the reload race — item 4). */
    ensureModelViewer().then(wire, fallToSpin);
  }

  /* ================= interactive figures (John 2026-07-06) =================
     FIG.1 phase-diagram live probe (cb-sfe-physics) + counter-rotating orbit
     diagram (cb-compare). Same rails as the hero: idle-deferred, dataset init
     guards, per-figure IO pause, document.hidden pause, scoped section:unload
     teardown, CLS-0 (SVG attribute/opacity writes only), zero per-frame
     allocations. STATIC mode (RM / saveData / low-memory): no ambient motion,
     no pulses — but direct probe placement (pointer/keyboard) and orbit
     spotlighting still respond with static updates. */
  var FIGSTATIC = RM || SAVE || LOWMEM;

  function cbBezPt(p, t) {
    var u = 1 - t;
    var a = u * u * u,
      b = 3 * u * u * t,
      c = 3 * u * t * t,
      d = t * t * t;
    return [
      a * p[0] + b * p[2] + c * p[4] + d * p[6],
      a * p[1] + b * p[3] + c * p[5] + d * p[7],
    ];
  }

  function figProbe() {
    var fig = document.getElementById("cb-phasefig");
    if (!fig || fig.dataset.cbFigInit) return;
    fig.dataset.cbFigInit = "1";
    idle(function () {
      if (!fig.isConnected) return;
      var svg = fig.querySelector("svg");
      var probe = document.getElementById("cb-probe");
      var lx = document.getElementById("cb-probe-lx");
      var ly = document.getElementById("cb-probe-ly");
      var dot = document.getElementById("cb-probe-dot");
      var ro = document.getElementById("cb-probe-ro");
      var t1 = document.getElementById("cb-probe-t1");
      var t2 = document.getElementById("cb-probe-t2");
      var live = document.getElementById("cb-probe-live");
      var glow = document.getElementById("cb-ph-glow");
      var labels = {
        SOLID: document.getElementById("cb-ph-solid"),
        LIQUID: document.getElementById("cb-ph-liquid"),
        GAS: document.getElementById("cb-ph-gas"),
        SUPERCRITICAL: document.getElementById("cb-ph-super"),
      };
      if (!svg || !probe || !lx || !ly || !dot || !ro || !t1 || !t2 || !glow)
        return;

      /* the three phase-boundary beziers (same control points as the markup),
         sampled once into polylines for the region classifier */
      var N = 24;
      function sample(p) {
        var out = [];
        for (var i = 0; i <= N; i++) out.push(cbBezPt(p, i / N));
        return out;
      }
      var sSub = sample([60, 330, 130, 322, 190, 300, 232, 262]);
      var sVap = sample([232, 262, 268, 216, 306, 156, 330, 116]);
      var sFus = sample([232, 262, 226, 180, 222, 100, 218, 30]);
      function yOnX(poly, x) {
        var i;
        for (i = 1; i < poly.length - 1; i++) if (poly[i][0] >= x) break;
        var a = poly[i - 1],
          b = poly[i],
          f = (x - a[0]) / (b[0] - a[0] || 1);
        return a[1] + (b[1] - a[1]) * Math.max(0, Math.min(1, f));
      }
      function xFusOnY(y) {
        var i;
        y = Math.max(30, Math.min(262, y));
        for (i = 1; i < sFus.length - 1; i++) if (sFus[i][1] <= y) break;
        var a = sFus[i - 1],
          b = sFus[i],
          f = (y - a[1]) / (b[1] - a[1] || 1);
        return a[0] + (b[0] - a[0]) * Math.max(0, Math.min(1, f));
      }
      function classify(x, y) {
        /* 0.01px epsilon: a probe placed exactly ON the critical point must
           read supercritical (float client→viewBox round-trip can land at
           329.999…, harness-caught 2026-07-06) */
        if (x >= 329.99 && y <= 116.01) return "SUPERCRITICAL";
        var gasY = x >= 330 ? 116 : x < 232 ? yOnX(sSub, x) : yOnX(sVap, x);
        if (y > gasY) return "GAS";
        if (x <= xFusOnY(y)) return "SOLID";
        return "LIQUID";
      }

      /* linear calibration: triple point (232,262)=(-56.6 °C, 5.18 bar),
         critical point (330,116)=(31.1 °C, 73.8 bar) */
      function tempAt(x) {
        return -56.6 + ((x - 232) * (31.1 + 56.6)) / (330 - 232);
      }
      function presAt(y) {
        return Math.max(0, 5.18 + ((262 - y) * (73.8 - 5.18)) / (262 - 116));
      }

      var px = 330,
        py = 116,
        lastRegion = "",
        pulseOn = false,
        auto = !FIGSTATIC,
        autoT = 0,
        autoCycles = 0,
        userOn = false,
        visible = false,
        raf = 0,
        last = 0,
        liveTimer = 0,
        liveMsg = "";

      function queueLive() {
        if (!live || !userOn) return;
        liveMsg =
          tempAt(px).toFixed(1) +
          " degrees celsius, " +
          presAt(py).toFixed(1) +
          " bar, " +
          lastRegion.toLowerCase() +
          " region";
        if (!liveTimer)
          liveTimer = setTimeout(function () {
            liveTimer = 0;
            live.textContent = liveMsg;
          }, 500);
      }

      function render(x, y) {
        px = Math.max(60, Math.min(500, x));
        py = Math.max(20, Math.min(352, y));
        var region = classify(px, py);
        lx.setAttribute("x2", px);
        lx.setAttribute("y1", py);
        lx.setAttribute("y2", py);
        ly.setAttribute("x1", px);
        ly.setAttribute("x2", px);
        ly.setAttribute("y2", py);
        dot.setAttribute("cx", px);
        dot.setAttribute("cy", py);
        var rx = px > 324 ? px - 188 : px + 12; /* 176px box + 12 margin */
        var ry = py < 66 ? py + 32 : Math.min(py - 6, 358);
        ro.setAttribute(
          "transform",
          "translate(" + Math.max(62, rx) + "," + ry + ")",
        );
        t1.textContent =
          tempAt(px).toFixed(1) + " °C · " + presAt(py).toFixed(1) + " bar";
        t2.textContent = region;
        probe.setAttribute("opacity", "1");
        if (region !== lastRegion) {
          for (var k in labels)
            if (labels[k])
              labels[k].setAttribute(
                "fill",
                k === region ? "#f9c558" : "#b6b6b6",
              );
          lastRegion = region;
        }
        pulseOn = region === "SUPERCRITICAL" && !FIGSTATIC;
        if (pulseOn) play();
        queueLive();
      }

      /* idle attract loop: GAS → critical point (pause) → SUPERCRITICAL,
         7 s cycle; the first real interaction retires it for the session */
      function easeIO(t) {
        return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      }
      function qb(ax, ay, cx2, cy2, bx, by, t) {
        var u = 1 - t;
        return [
          u * u * ax + 2 * u * t * cx2 + t * t * bx,
          u * u * ay + 2 * u * t * cy2 + t * t * by,
        ];
      }
      function autoStep(t) {
        var p;
        if (t < 2600) p = qb(430, 300, 400, 210, 330, 116, easeIO(t / 2600));
        else if (t < 3600) p = [330, 116];
        else if (t < 5200)
          p = qb(330, 116, 380, 70, 420, 60, easeIO((t - 3600) / 1600));
        else p = [420, 60];
        render(p[0], p[1]);
      }
      function frame(now) {
        raf = 0;
        var dt = Math.min(48, now - last);
        last = now;
        if (auto) {
          autoT += dt;
          if (autoT >= 7000) {
            autoT %= 7000;
            /* final review (Mei/Sora): the instrument demonstrates three
               times, then rests parked on the critical point */
            if (++autoCycles >= 3) {
              auto = false;
              render(330, 116);
            }
          }
          if (auto) autoStep(autoT);
        }
        if (pulseOn)
          glow.setAttribute(
            "opacity",
            (0.75 + 0.25 * Math.sin(now * 0.004)).toFixed(3),
          );
        else glow.setAttribute("opacity", "1");
        if ((auto || pulseOn) && visible && !document.hidden)
          raf = requestAnimationFrame(frame);
      }
      function play() {
        if (!raf && visible && !document.hidden && (auto || pulseOn)) {
          last = performance.now();
          raf = requestAnimationFrame(frame);
        }
      }
      function stop() {
        if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
      }

      function onPtr(e) {
        var r = svg.getBoundingClientRect();
        if (!r.width) return;
        var x = ((e.clientX - r.left) / r.width) * 520;
        var y = ((e.clientY - r.top) / r.height) * 400;
        if (x < 52 || x > 508 || y < 12 || y > 360) return;
        auto = false;
        userOn = true;
        render(x, y);
      }
      function onKey(e) {
        var step = e.shiftKey ? 12 : 4;
        var dx =
          e.key === "ArrowLeft" ? -step : e.key === "ArrowRight" ? step : 0;
        var dy = e.key === "ArrowUp" ? -step : e.key === "ArrowDown" ? step : 0;
        if (e.key === "Home") {
          dx = 330 - px;
          dy = 116 - py;
        } else if (!dx && !dy) return;
        auto = false;
        userOn = true;
        render(px + dx, py + dy);
        e.preventDefault();
      }
      svg.addEventListener("pointermove", onPtr, { passive: true });
      svg.addEventListener("pointerdown", onPtr, { passive: true });
      fig.addEventListener("keydown", onKey);

      var io = null;
      if ("IntersectionObserver" in window) {
        io = new IntersectionObserver(
          function (es) {
            visible = es[0].isIntersecting;
            if (visible) play();
            else stop();
          },
          { threshold: 0.05 },
        );
        io.observe(fig);
      } else {
        visible = true;
        play();
      }
      function onVis() {
        if (!fig.isConnected) return;
        if (document.hidden) stop();
        else play();
      }
      document.addEventListener("visibilitychange", onVis);

      var section = (fig.closest && fig.closest(".shopify-section")) || null;
      function teardown(e) {
        var mine =
          !fig.isConnected ||
          (e &&
            e.target &&
            section &&
            (e.target === section || e.target.contains(fig)));
        if (!mine) return;
        stop();
        if (io && io.disconnect) io.disconnect();
        document.removeEventListener("visibilitychange", onVis);
        svg.removeEventListener("pointermove", onPtr);
        svg.removeEventListener("pointerdown", onPtr);
        fig.removeEventListener("keydown", onKey);
        if (liveTimer) {
          clearTimeout(liveTimer);
          liveTimer = 0;
        }
        document.removeEventListener("shopify:section:unload", teardown);
      }
      document.addEventListener("shopify:section:unload", teardown);
    }, 1800);
  }

  function figOrbits() {
    var fig = document.getElementById("cb-orbitfig");
    if (!fig || fig.dataset.cbFigInit) return;
    fig.dataset.cbFigInit = "1";
    idle(function () {
      if (!fig.isConnected) return;
      var svg = fig.querySelector("svg");
      var herb = document.getElementById("cb-orb-herb");
      var ORB = {
        outer: {
          ell: document.getElementById("cb-orb-outer"),
          sat: document.getElementById("cb-orb-sat-outer"),
          cap: document.getElementById("cb-orb-cap-outer"),
          trail: svg ? svg.querySelectorAll(".cb-orb-tr-o") : [],
          rx: 220,
          ry: 78,
          th: 0 /* satellite starts at (500,120) */,
          dir: -1 /* θ DECREASES → screen COUNTER-clockwise (see below) */,
          T: 14000,
          baseW: "1.8",
          spotW: "2.6",
          baseFill: "#f5a500",
        },
        inner: {
          ell: document.getElementById("cb-orb-inner"),
          sat: document.getElementById("cb-orb-sat-inner"),
          cap: document.getElementById("cb-orb-cap-inner"),
          trail: svg ? svg.querySelectorAll(".cb-orb-tr-i") : [],
          rx: 150,
          ry: 46,
          th: Math.PI /* satellite starts at (130,120) */,
          dir: 1 /* θ INCREASES → screen CLOCKWISE */,
          T: 9000,
          baseW: "1.4",
          spotW: "2.2",
          baseFill: "#b6b6b6",
        },
      };
      /* DIRECTION NOTE (owner spec: inner clockwise, outer counter-clockwise
         AS SEEN ON SCREEN): SVG's y-axis points DOWN, so with
         pos = (cx + rx·cosθ, cy + ry·sinθ) an INCREASING θ moves the
         satellite top→right→bottom→left = CLOCKWISE on screen. Hence
         inner dir = +1, outer dir = -1. Asserted numerically in the harness. */
      if (!svg || !herb || !ORB.outer.sat || !ORB.inner.sat) return;
      var CX = 280,
        CY = 120,
        BOOST = 2.5,
        TRAIL_STEP = 0.16,
        TRAIL_A = [".4", ".26", ".14"];
      var spot = "",
        visible = false,
        raf = 0,
        last = 0,
        lastPtrType = "";

      function frame(now) {
        raf = 0;
        var dt = Math.min(48, now - last);
        last = now;
        for (var k in ORB) {
          var o = ORB[k];
          o.th += ((Math.PI * 2) / o.T) * o.dir * (spot === k ? BOOST : 1) * dt;
          o.sat.setAttribute("cx", (CX + o.rx * Math.cos(o.th)).toFixed(2));
          o.sat.setAttribute("cy", (CY + o.ry * Math.sin(o.th)).toFixed(2));
          for (var i = 0; i < o.trail.length; i++) {
            /* trail ghosts sit at EARLIER angular positions — opposite the
               direction of travel for each orbit */
            var ta = o.th - o.dir * TRAIL_STEP * (i + 1);
            o.trail[i].setAttribute(
              "cx",
              (CX + o.rx * Math.cos(ta)).toFixed(2),
            );
            o.trail[i].setAttribute(
              "cy",
              (CY + o.ry * Math.sin(ta)).toFixed(2),
            );
            if (!o.trail[i].dataset.cbOn) {
              o.trail[i].dataset.cbOn = "1";
              o.trail[i].setAttribute("opacity", TRAIL_A[i] || ".14");
            }
          }
        }
        herb.setAttribute(
          "r",
          (9.75 + 0.75 * Math.sin(now * 0.0021)).toFixed(2),
        );
        if (visible && !document.hidden) raf = requestAnimationFrame(frame);
      }
      function play() {
        if (!raf && visible && !document.hidden && !FIGSTATIC) {
          last = performance.now();
          raf = requestAnimationFrame(frame);
        }
      }
      function stop() {
        if (raf) {
          cancelAnimationFrame(raf);
          raf = 0;
        }
      }

      function applySpot(name) {
        spot = name;
        for (var k in ORB) {
          var o = ORB[k];
          var on = spot === k;
          var dim = spot && !on;
          var op = dim ? ".35" : "1";
          o.ell.setAttribute("opacity", op);
          o.sat.setAttribute("opacity", op);
          o.cap.setAttribute("opacity", dim ? ".35" : "1");
          o.cap.setAttribute("fill", on ? "#f9c558" : o.baseFill);
          o.ell.setAttribute("stroke-width", on ? o.spotW : o.baseW);
          for (var i = 0; i < o.trail.length; i++)
            if (o.trail[i].dataset.cbOn)
              o.trail[i].setAttribute(
                "opacity",
                dim ? ".1" : TRAIL_A[i] || ".14",
              );
        }
      }
      function orbAt(e) {
        var t = e.target && e.target.closest && e.target.closest("[data-orb]");
        return t ? t.getAttribute("data-orb") : "";
      }
      function onOver(e) {
        if (e.pointerType !== "mouse") return;
        var o = orbAt(e);
        if (o) applySpot(o);
      }
      function onOut(e) {
        if (e.pointerType !== "mouse") return;
        if (orbAt(e)) applySpot("");
      }
      function onDown(e) {
        lastPtrType = e.pointerType || "";
      }
      function onClick(e) {
        var o = orbAt(e);
        if (lastPtrType === "mouse") {
          if (o) applySpot(o);
          return;
        }
        /* touch: tap toggles; tapping elsewhere in the figure clears */
        applySpot(o && o !== spot ? o : "");
      }
      function onKey(e) {
        if (e.key !== "Enter" && e.key !== " ") return;
        applySpot(spot === "" ? "outer" : spot === "outer" ? "inner" : "");
        e.preventDefault();
      }
      svg.addEventListener("pointerover", onOver);
      svg.addEventListener("pointerout", onOut);
      svg.addEventListener("pointerdown", onDown, { passive: true });
      svg.addEventListener("click", onClick);
      fig.addEventListener("keydown", onKey);

      var io = null;
      if ("IntersectionObserver" in window) {
        io = new IntersectionObserver(
          function (es) {
            visible = es[0].isIntersecting;
            if (visible) play();
            else stop();
          },
          { threshold: 0.05 },
        );
        io.observe(fig);
      } else {
        visible = true;
        play();
      }
      function onVis() {
        if (!fig.isConnected) return;
        if (document.hidden) stop();
        else play();
      }
      document.addEventListener("visibilitychange", onVis);

      var section = (fig.closest && fig.closest(".shopify-section")) || null;
      function teardown(e) {
        var mine =
          !fig.isConnected ||
          (e &&
            e.target &&
            section &&
            (e.target === section || e.target.contains(fig)));
        if (!mine) return;
        stop();
        if (io && io.disconnect) io.disconnect();
        document.removeEventListener("visibilitychange", onVis);
        svg.removeEventListener("pointerover", onOver);
        svg.removeEventListener("pointerout", onOut);
        svg.removeEventListener("pointerdown", onDown);
        svg.removeEventListener("click", onClick);
        fig.removeEventListener("keydown", onKey);
        document.removeEventListener("shopify:section:unload", teardown);
      }
      document.addEventListener("shopify:section:unload", teardown);
    }, 1800);
  }

  /* Boot the deferred visuals now, and re-run on theme-editor section
           reloads. All initializers are idempotent (each guards its own root
           node), so re-entry never creates a second loop / context / binding. */
  function cbInitDeferred() {
    sky();
    ladder();
    figProbe();
    figOrbits();
  }
  cbInitDeferred();
  document.addEventListener("shopify:section:load", cbInitDeferred);
  /* Codex P2 (2026-07-05): if the header section reloads in the theme editor
     while the drawer is open, release the scroll lock + inert state */
  document.addEventListener("shopify:section:unload", function () {
    document.documentElement.style.overflow = "";
    ["MainContent", "cb-header"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.removeAttribute("inert");
    });
  });

  /* ---- sticky buy bar (audit 2026-07-05) ---- */
  (function stickyBuy() {
    var bar = document.getElementById("cb-stickybuy");
    var lineup = document.getElementById("lineup");
    if (!bar || !lineup || bar.dataset.cbWired) return;
    bar.dataset.cbWired = "1";
    bar.hidden = false;
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (en) {
          /* show once the lineup's bottom has passed above the viewport */
          var below = en.boundingClientRect.bottom < 0;
          bar.classList.toggle("is-on", below && !en.isIntersecting);
        });
      },
      { threshold: 0 },
    );
    io.observe(lineup);
  })();

  /* ---- 20g box / Coffee Tabs pouch stage switcher (John 2026-07-03) ----
     Delegated once at document level (survives theme-editor section reloads).
     Swaps the stage model-viewer's src/poster/alt/orbit and the spec copy;
     the spin scrub fallback is 20g-only, so it hides while Tabs is active. */
  /* ROOT-CAUSE FIX (2026-07-03): the wiring guard previously wrote
     data-cb-mv-swap onto <html>, so e.target.closest("[data-cb-mv-swap]")
     matched <html> on EVERY page click — which set the stage src to "null",
     errored the viewer away and hid the spin fallback (the "black stage").
     Guard attribute renamed + selector scoped to button + data-src required. */
  /* agy P1 fix (2026-07-06): resolve spin[0] FRESH at use time via
     getAssets() — a load-time cache violates this file's own "read the asset
     map fresh" hardening (a theme-editor asset swap would serve a stale URL). */
  function assetsSpin0() {
    var j = getAssets();
    return (j && j.spin && j.spin[0]) || "";
  }
  if (!document.documentElement.dataset.cbMvSwapWired) {
    document.documentElement.dataset.cbMvSwapWired = "1";
    document.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-cb-mv-swap]");
      if (!b || !b.getAttribute("data-src")) return;
      var mv = document.getElementById("cb-mv-stage");
      var grp = b.closest(".cb-c8-mvswap");
      if (grp) {
        grp.querySelectorAll("[data-cb-mv-swap]").forEach(function (x) {
          x.classList.remove("cb-btn--primary");
          x.classList.add("cb-btn--secondary");
          x.setAttribute("aria-pressed", "false");
        });
      }
      b.classList.add("cb-btn--primary");
      b.classList.remove("cb-btn--secondary");
      b.setAttribute("aria-pressed", "true");
      if (mv) {
        if (b.getAttribute("data-poster"))
          mv.setAttribute("poster", b.getAttribute("data-poster"));
        mv.setAttribute("alt", b.getAttribute("data-alt") || "");
        if (b.getAttribute("data-orbit"))
          mv.setAttribute("camera-orbit", b.getAttribute("data-orbit"));
        mv.setAttribute("src", b.getAttribute("data-src"));
      }
      var dims = document.getElementById("cb-3d-dims");
      if (dims && b.getAttribute("data-dims"))
        dims.textContent = b.getAttribute("data-dims");
      var sub = document.getElementById("cb-3d-sub");
      if (sub && b.getAttribute("data-sub"))
        sub.textContent = b.getAttribute("data-sub");
      var shop = document.getElementById("cb-3d-shop");
      if (shop) {
        if (b.getAttribute("data-shop"))
          shop.setAttribute("href", b.getAttribute("data-shop"));
        if (b.getAttribute("data-shoplabel"))
          shop.textContent = b.getAttribute("data-shoplabel");
      }
      var spin = document.getElementById("cb-spin-stage");
      if (spin) {
        if (mv) {
          /* viewer alive: spin scrub only backs the 20g */
          spin.style.display =
            b.getAttribute("data-spin") === "1" ? "" : "none";
          delete spin.dataset.cbPosterLock;
        } else {
          /* audit 2026-07-05: fallback path (no WebGL / saveData / module
             timeout) — every pack still gets a static poster instead of a
             blank stage. Scrub pauses while a non-20g poster is locked in. */
          spin.style.display = "";
          var simg = spin.querySelector("img");
          if (b.getAttribute("data-spin") === "1") {
            delete spin.dataset.cbPosterLock;
            var spin0 = assetsSpin0(); /* fresh read (agy P1) */
            if (simg && spin0) simg.src = spin0;
            spin.setAttribute(
              "aria-label",
              "CaféBank 20 g box, drag left or right to rotate the 360° view",
            );
          } else if (simg && b.getAttribute("data-poster")) {
            spin.dataset.cbPosterLock = "1";
            simg.src = b.getAttribute("data-poster");
            spin.setAttribute(
              "aria-label",
              b.getAttribute("data-alt") || "Product photo",
            );
          }
        }
      }
    });
  }
})();
